import React, { useContext } from 'react';
import { Box, Typography } from '@mui/material';
import { UiContext } from 'uiContext';
import { WeatherType } from 'mobx/commonTypes';
import { getWeatherConditionLabel } from './helper';

import IconVerticalLine from 'icons/weather/iconVerticalLine';
import WeatherIconWrapper from './weatherIconWrapper';

export default function WeatherForecastMobile({
  weather,
}: {
  weather: WeatherType;
}) {
  const {
    spacings: { sp },
  } = useContext(UiContext);

  const { cond, temp } = weather;

  return (
    <Box
      sx={{
        py: sp.s40,
      }}
    >
      <Typography variant="f14">Погодные условия</Typography>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: sp.s25,
          marginTop: sp.s30,
        }}
      >
        <WeatherIconWrapper condition={cond} sizeKey="20x20" />
        <Typography variant="f14">{getWeatherConditionLabel(cond)}</Typography>
        <IconVerticalLine />
        <Typography variant="f14">{temp} &#8451;</Typography>
      </Box>
    </Box>
  );
}
